import type { Link } from './link.model';

export enum HeaderAction {
  CONTACT_US = 'contact-us',
  START_OVER = 'start-over'
}

export interface HeaderLink extends Link {
  action?: HeaderAction;
  iconName?: string;
  tooltipText?: string;
}

export enum PrescriptionTab {
  PRESCRIPTIONS = 'prescriptions',
  PHARMACIES = 'pharmacies',
  COVERAGE = 'coverage',
  ANNUAL_COST = 'annual-cost'
}
